export default "__VITE_ASSET__BXsooc4V__"